<template>
  <div v-if="h5ConfigDetails" class="activity-nav" :style="`background: ${h5ConfigDetails[0]['fontColor']['navBg'][0]};`">
    <div class="back" @click="_back">
      <img :src="require('@/assets/img/nav_back.png')" alt="">
    </div>
    <p class="activity-title" :style="`color: ${h5ConfigDetails[0]['fontColor']['navFontColor'][0]};`">{{h5ConfigDetails[0]['activitySetting']['title'][0]}}</p>
    <div v-if="h5ConfigDetails[0].activitySetting.shareIcon[0]" class="share" @click="_share">
      <img :src="require('@/assets/img/nav_share.png')" alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import appBridge from '@/config/appBridge'

export default {
  name: 'ActivityNav',
  props: ['backFn'],
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['statusBarHeight', 'isInIos', 'h5ConfigDetails', 'h5ConfigImgPath'])
  },
  methods: {
    _back () {
      this.backFn()
    },
    _share () {
      const activitySetting = this.h5ConfigDetails[0].activitySetting
      console.log(activitySetting)

      // window.overallTaskId && window.eventBus.$emit('shareInTask', window.overallTaskId)
      // window.overallCouponId && window.eventBus.$emit('shareInCoupon', window.overallCouponId)
      // appBridge.shareByApp(activitySetting.shareTitle[0], activitySetting.shareContent[0], activitySetting.shareIcon[0], window.location.href)
      appBridge.shareByApp(activitySetting.shareTitle[0], activitySetting.shareContent[0], activitySetting.shareIcon[0], window.location.href)
    }
  }
}
</script>

<style scoped lang="less">
  .activity-nav {
    width: 100%;
    height: 4.2rem;
    line-height: 4.2rem;
    position: relative;
    background: rgb(20, 27, 37);
    .activity-title{
      line-height: 4.2rem;
      font-size: 1.7rem;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
    }
    .share {
      font-size: 1.4rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 4.2rem;
      position: absolute;
      height: 1.6rem;
      right: 1.93rem;
      top: 1.3rem;
      img {
        width: auto;
        height: 100%;
        display: block;
      }
    }
  }
  // 白色返回按钮
  .back {
    position: absolute;
    left: 1.93rem;
    top: 1.3rem;
    display: inline-block;
    height: 1.6rem;
  }
  .back img {
    width: auto;
    height: 100%;
    display: block;
  }
  .app-nav p {
    font-size: 1.5rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    height: 4.2rem;
    line-height: 4.2rem;
  }
</style>
